import { render } from "./FlowPanelContentNote.vue?vue&type=template&id=03505493&scoped=true&ts=true"
import script from "./FlowPanelContentNote.vue?vue&type=script&lang=ts"
export * from "./FlowPanelContentNote.vue?vue&type=script&lang=ts"

import "./FlowPanelContentNote.vue?vue&type=style&index=0&id=03505493&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03505493"]])

export default __exports__